import * as React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import ModalConfirmation from '../ui/ModalConfirmation';
import ModalDragDropImport from '../ui/ModalDragDropImport';
import { createList, deleteList, setCurrentList, updateList } from '../../actions/actions';
import { IS_FILTERING } from '../../actions/constants';
import { forceDownload, exportableDistList, sanitizeFilename, renameIfDuplicate } from '../../helpers/utility';

import './styles/ActionsMenu.scss';

export class ActionsMenuClass extends React.Component {
	constructor(props, context) {
		super(props, context)

		this.state = {
			showModal: false,
			showModalDragDrop: false,
			dataDragDropCSVImported: {},
			dataDragDropExcluded: [],
		};
	}

	handleModalConfirmation = () => {
		const { selectedList, deleteList } = this.props;

		this.setState({ showModal: false });
		if (selectedList.id && selectedList.id.length > 0) {
			deleteList(selectedList.id);
		}
	}

	handleModalDragDropConfirmation = () => {
		const { selectedList, updateList } = this.props;
		const { dataDragDropCSVImported } = this.state
		//dispatch action update data
		updateList(selectedList.id, dataDragDropCSVImported)
		this.setState({ showModalDragDrop: false })
	}

	handleModalClose = () => {
		this.setState({ showModal: false });
	}

	requestConfirmation = () => {
		this.setState({ showModal: true });
	}

	exportList = (selectedList, selectedDistList, accounts) => {
		const exportFilename = `${sanitizeFilename(`distribution_${selectedList.name}`)}.csv`;
		// Build a CSV and force the browser to download it
		forceDownload(exportFilename, exportableDistList(selectedList.id, selectedList.name, selectedDistList, accounts));
	}

	toggleModalDragDrop = (value) => {
		this.setState({ showModalDragDrop: value })
	}

	duplicateList = (selectedList) => {
		const { name, distList } = selectedList;
		const { allLists } = this.props;
		const newName = renameIfDuplicate(allLists, name);
		this.props.createList(newName, distList);
	}

	getDataCSVImported = (dataDragDropCSVImported) => {
		this.setState({ dataDragDropCSVImported })
	}
	render() {
		const { selectedList, allLists, accounts, rename, i18n, tree, addRemoveItem, checkForEmptyList } = this.props;
		const { showModal, showModalDragDrop } = this.state
		const selectedListInfo = allLists.filter(x => x.id === selectedList.id);
		// Get the list of selected accounts
		let selectedDistList = [];
		if (selectedListInfo[0]) {
			selectedDistList = selectedListInfo[0].distList;
		}

		return (
			<div id="actions_menu">
				<ul>
					<li onClick={
						rename
					}>
						{i18n.t('RENAME')}
					</li>
					<li onClick={() => {
						this.requestConfirmation(selectedList.id)
					}}>
						{i18n.t('DELETE')}
					</li>
					<li onClick={() => this.exportList(selectedList, selectedDistList, accounts)}>
						{i18n.t('EXPORT')}
					</li>
					<li onClick={() => this.toggleModalDragDrop(true)}>
						{i18n.t('IMPORT')}
					</li>
					<li onClick={() => this.duplicateList(selectedList, selectedDistList, accounts)}>
						{i18n.t('DUPLICATE')}
					</li>
				</ul>
				<ModalConfirmation
					show={showModal}
					handleConfirmation={this.handleModalConfirmation}
					handleClose={this.handleModalClose}
					title={i18n.t('DELETE_THIS_LIST')}
					body={i18n.t('DELETE_THIS_LIST_INSTRUCTIONS', { name: selectedList.name })}
					closeButton={i18n.t('CANCEL')}
					confirmButton={i18n.t('DELETE')}
					closeButtonStyle={'link'} // Bootstrap button style
					confirmButtonStyle={'link'} // Bootstrap button style
					confirmButtonClass={'danger'} // Override style for unique button
				/>
				{showModalDragDrop && <ModalDragDropImport
					show={showModalDragDrop}
					tree={tree}
					allLists={allLists}
					handleConfirmation={this.handleModalDragDropConfirmation}
					toggleModalDragDrop={this.toggleModalDragDrop}
					getDataCSVImported={this.getDataCSVImported}
					addRemoveItem={addRemoveItem}
					checkForEmptyList={checkForEmptyList}
					title={`${i18n.t('IMPORT_DISTRIBUTION_LIST_FOR')} ${selectedList.name}`}
				/>}
			</div>
		);
	}
}

ActionsMenuClass.propTypes = {
	deleteList: PropTypes.func.isRequired,
	createList: PropTypes.func.isRequired,
	updateList: PropTypes.func.isRequired,
	rename: PropTypes.func.isRequired,
	selectedList: PropTypes.shape({}).isRequired,
	allLists: PropTypes.array.isRequired,
	addRemoveItem: PropTypes.func.isRequired,
	checkForEmptyList: PropTypes.func.isRequired,
	tree: PropTypes.shape({}).isRequired,
	accounts: PropTypes.shape({}),
	nameElement: PropTypes.instanceOf(Element),
	i18n: PropTypes.shape({}).isRequired,
};

const mapDispatchToProps = dispatch => ({
	deleteList: id => {
		// unset the current list
		dispatch(setCurrentList('', false));
		dispatch(deleteList(id));
	},
	createList: (name, list) => {
		dispatch(createList(name, list));
		dispatch({ type: IS_FILTERING, payload: false });
	},
	updateList: (selectedList, list) => {
		dispatch(updateList(selectedList, { distList: list }))
	},
});

const mapStateToProps = (state) => ({
	selectedList: state.selectedList,
	allLists: state.allLists,
	accounts: state.accounts,
});

const ActionsMenu = connect(
	mapStateToProps,
	mapDispatchToProps
)(ActionsMenuClass);

export default withTranslation()(ActionsMenu);
